export const DISTRIBUTION_TABLE_COLUMNS = ['name', 'altName', 'color', 'logo', 'background', 'oneTimeEnrollmentFee', 'actions'];

export const DEFAULT_PAGE_PARAMS = {
  PageIndex: 0,
  PageSize: 10,
  ByName: '',
  skipLoader: true,
};

export const FILTER_TABS_CONFIG = [
  {
    icon: 'checklist',
    label: 'Distribution',
  },
];
